import React, { useEffect, useState } from "react";
import Footer from "./Footer";
import Navbar from "./Navbar_old";
import "bootstrap-icons/font/bootstrap-icons.css";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";

const API = "https://rishtey.rishteymatch.in/api2";      // API calls ke liye
const BASE_URL = "https://rishtey.rishteymatch.in"; // Correct for images

const Settings = () => {
  const navigate = useNavigate();
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const loggedUser = JSON.parse(localStorage.getItem("currentUser"));

  // ================= FETCH USER =================
  useEffect(() => {
    const fetchUser = async () => {
      if (!loggedUser?._id) {
        setLoading(false);
        return;
      }

      try {
        const res = await axios.get(`${API}/api/user/${loggedUser._id}`);
        if (res.data?.success) {
          setUser(res.data.user);
        }
      } catch (err) {
        console.error("Fetch user error:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchUser();
  }, []);

  // ================= LOADING =================
  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center vh-100">
        <div className="spinner-border text-warning"></div>
      </div>
    );
  }

  // ================= USER NOT FOUND =================
  if (!user) {
    return (
      <div className="text-center mt-5 text-danger">
        <h5>User not found! Please login again.</h5>
      </div>
    );
  }

  // ================= PROFILE IMAGE (FIXED) =================
const BASE_URL = "https://rishtey.rishteymatch.in"; // no /api2 here

let profileImage = "https://cdn-icons-png.flaticon.com/512/149/149071.png";
if (user?.image) {
  if (user.image.startsWith("http")) profileImage = user.image;
  else profileImage = `${BASE_URL}${user.image.startsWith('/') ? '' : '/'}${user.image}`;
}

  // ================= TOGGLE STATUS =================
  const toggleStatus = async () => {
    try {
      const newStatus = user.status === "Active" ? "Inactive" : "Active";
      await axios.put(`${API}/api/user/${user._id}`, { status: newStatus });
      setUser((prev) => ({ ...prev, status: newStatus }));
    } catch (err) {
      console.error("Status update error:", err);
    }
  };

  return (
    <>
      <Navbar />

      <div
        className="d-flex justify-content-center align-items-center"
        style={{
          minHeight: "80vh",
          background: "linear-gradient(180deg,#0f0f0f,#1c1c1c)",
          color: "#fff",
        }}
      >
        <div
          style={{
            width: "90%",
            maxWidth: "380px",
            padding: "25px",
            borderRadius: "20px",
            background: "rgba(255,255,255,0.05)",
            backdropFilter: "blur(10px)",
            border: "1px solid rgba(255,255,255,0.1)",
            boxShadow: "0 8px 30px rgba(0,0,0,0.6)",
            textAlign: "center",
          }}
        >
          {/* PROFILE IMAGE */}
<img
  src={profileImage}
  alt="profile"
  width="100"
  height="100"
  style={{ borderRadius: "50%", objectFit: "cover", border: "3px solid #fff" }}
  onError={(e) => { e.target.onerror = null; e.target.src="https://cdn-icons-png.flaticon.com/512/149/149071.png"; }}
/>




          <h4 className="fw-bold">
            {user.full_name || user.name || "Guest"}
          </h4>

          <p style={{ color: "#ffc107" }}>
            <i className="bi bi-gem me-1"></i>
            {user.membership || "Free Member"}
          </p>

          <hr style={{ borderColor: "rgba(255,255,255,0.1)" }} />

          {/* STATUS */}
          <div className="d-flex justify-content-between align-items-center mb-2">
            <span>
              <i className="bi bi-check-circle me-2"></i>Status
            </span>
            <button
              onClick={toggleStatus}
              className={`btn btn-sm ${
                user.status === "Active"
                  ? "btn-success"
                  : "btn-secondary"
              }`}
            >
              {user.status}
            </button>
          </div>

          <InfoLine icon="bi-clock-history" label="Plan" value={user.plan || "Free"} />
          <InfoLine icon="bi-person-badge" label="Number" value={user.mobile} />
          <InfoLine icon="bi-envelope" label="Email" value={user.email} />
          <InfoLine icon="bi-geo-alt" label="State" value={user.user_state} />

          <div className="d-grid gap-2 mt-4">
            <Link to="/membership" className="btn btn-warning fw-bold">
              <i className="bi bi-stars me-1"></i> Upgrade Plan
            </Link>

            <button
              onClick={() => navigate("/myprofile")}
              className="btn fw-bold"
              style={{
                border: "1px solid #ffc107",
                color: "#ffc107",
                background: "transparent",
              }}
            >
              Profile
            </button>
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
};

// ================= INFO LINE =================
const InfoLine = ({ icon, label, value }) => (
  <div className="d-flex justify-content-between py-1">
    <span>
      <i className={`bi ${icon} me-2`}></i>
      {label}
    </span>
    <span className="fw-semibold">{value || "-"}</span>
  </div>
);

export default Settings;
